import {disableScrolling, enableScrolling} from '../utils/scroll-lock';

const burgerBtn = document.querySelector('.main-nav__toggle');
const navBlock = document.querySelector('.main-nav__wrapper');
const breakpointLg = window.matchMedia('(min-width:1024px)');
const innerContentsBlocks = document.querySelectorAll('.inner-nav__content');
const mobileLinks = document.querySelectorAll('.inner-nav__btn');
const navList = document.querySelector('.header__nav-list');


const closeWhenTap = () => {
  if (!breakpointLg.matches) {
    const links = navBlock.querySelectorAll('a');
    if (links) {
      links.forEach((el) => {
        el.addEventListener('click', () => {
          closeMenu();
        });
      });
    }
  }
};

const openMenu = () => {
  burgerBtn.ariaPressed = 'true';
  navBlock.classList.add('active');
  burgerBtn.classList.add('open');
  window.disableBodyScroll(navBlock, {
    reserveScrollBarGap: true,
  });
  // window.disableBodyScroll(navList);
  burgerBtn.classList.add('no-pointer');
  setTimeout(() => {
    burgerBtn.classList.remove('no-pointer');
  }, 1000);
};

const closeMenu = () => {
  burgerBtn.ariaPressed = 'false';
  navBlock.classList.remove('active');
  burgerBtn.classList.remove('open');
  // window.enableBodyScroll(navList);
  window.enableBodyScroll(navBlock);
  burgerBtn.classList.add('no-pointer');
  // closeInnerNav();
  setTimeout(() => {
    burgerBtn.classList.remove('no-pointer');
  }, 1200);
};

const closeMenuOnResize = () => {
  closeMenu();
};

// const initBurgerAction = () => {
//   if (burgerBtn) {
//     breakpointLg.addListener(closeMenuOnResize);
//     burgerBtn.addEventListener('click', () => {
//       if (burgerBtn.ariaPressed === 'true') {
//         closeMenu();
//       } else {
//         openMenu();
//       }
//     });
//   }
// };

// export default initBurgerAction;



const initBurger = () => {
  if (burgerBtn) {
    breakpointLg.addListener(closeMenuOnResize);
    burgerBtn.addEventListener('click', () => {
      if (burgerBtn.ariaPressed === 'true') {
        closeMenu();
      } else {
        openMenu();
      }
    });

    closeWhenTap();
  }
}

export {initBurger};
